const PRIME_MAKE = {
AUDI:{
    "name": "Audi",
    "website": "www.audi.com",
    "logo": "/make/AUDI.swg"
},
BMW:{
    "name": "BMW",
    "website": "www.bmw.com",
    "logo": "/make/BMW.swg"
},
MERCEDES:{
    "name": "Mercedes",
    "website": "https://www.mercedes-benz.de",
    "logo": "/make/MERCEDES.swg"
},
PORSCHE:{
    "name": "Porsche",
    "website": "https://www.porsche.com/",
    "logo": "/make/PORSCHE.swg"
},
ASTON_MARTIN:{
    "name": "Aston Martin",
    "website": "https://www.astonmartin.com/de",
    "logo": "/make/ASTON_MARTIN.swg"
},
BENTLEY:{
    "name": "Bentley",
    "website": "https://www.bentleymotors.com/",
    "logo": "/make/BENTLEY.swg"
},
LAMBORGHINI:{
    "name": "Lamborghini",
    "website": "https://www.lamborghini.com/en-en",
    "logo": "/make/LAMBORGHINI.swg"
},
MCLAREN:{
    "name": "McLaren",
    "website": "https://cars.mclaren.com/de-de",
    "logo": "/make/MCLAREN.swg"
},
ROLLS_ROYCE:{
    "name": "Rolls Royce",
    "website": "https://www.rolls-roycemotorcars.com/en_GB/home.html",
    "logo": "/make/ROLLS_ROYCE.swg"
},
TESLA:{
    "name": "Tesla",
    "website": "https://www.tesla.com/de_de/",
    "logo": "/make/TESLA.swg"
},
JAGUAR:{
    "name": "Jaguar",
    "website": "https://www.jaguar.de/index.html",
    "logo": "/make/JAGUAR.swg"
},
LAND_ROVER:{
    "name": "Land Rover",
    "website": "https://www.landrover.de/vehicles/range-rover/index.html",
    "logo": "/make/LAND_ROVER.swg"
},
MINI:{
    "name": "MINI",
    "website": "https://www.mini.de/de_DE/home.html",
    "logo": "/make/MINI.swg"
},
VOLVO:{
    "name": "VOLVO",
    "website": "https://www.volvocars.com/de",
    "logo": "/make/VOLVO.swg"
},
}

exports = module.exports = {
    PRIME_MAKE
}